export function isDraggingFiles(types: readonly string[] | undefined): boolean {
  return types?.includes('Files') ?? false;
}

export class Dropzone {
  constructor(private id: string) {
    const dropzone = document.getElementById(id);
    if (dropzone) {
      let enterTarget: EventTarget;
      document.ondragover = e => {
        e.dataTransfer.dropEffect = 'none';
        e.preventDefault();
      };

      document.ondragenter = e => {
        enterTarget = e.target;
        if (isDraggingFiles(e.dataTransfer?.types)) {
          dropzone.style.display = 'grid';
        }
      };

      document.ondragleave = e => {
        if (enterTarget === e.target) {
          dropzone.style.display = '';
        }
      };

      dropzone.ondragover = e => {
        e.dataTransfer.dropEffect = isDraggingFiles(e.dataTransfer.types) ? 'copy' : 'none';
        e.preventDefault();
        e.stopPropagation();
      };

      dropzone.ondrop = e => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        if (files.length) {
          (<HTMLInputElement>document.getElementById('files')).files = files;
          $("#uploadMessages").trigger("click");
        } else {
          dropzone.style.display = '';
        }
      };
    }
  }
}
